import { CLEAR_ACTIVE_LICENSE, FETCH_ACTIVE_LICENSE, SET_ACTIVE_LICENSE } from "../actions";

const initialState = {
    activeLicenseData: null,
    isLoading: false,
    error: null,
};

const activeLicenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ACTIVE_LICENSE:
            return { ...state, isLoading: true, error: null };

        case SET_ACTIVE_LICENSE:
            return { ...state, activeLicenseData: action.payload, isLoading: false, error: null };

        case CLEAR_ACTIVE_LICENSE:
            return { ...state, activeLicenseData: null, isLoading: false, error: null };

        default:
            return state;
    }
};

export default activeLicenseReducer;
